export default {
    "fr": {
        "abbreviation": {
            "recurrent": "REC",
            "onceAWeek": "1X/SEM",
            "onceAMonth": "1X/MOIS",
            "onceAYear": "1X/AN",
            "hourly": "H",
            "package": "F",
            "project": "P",
        },
        "button": {
            "import": "Importer",
            "export": "Exporter",
            "loginApikom": "Connexion Apikom",
            "loginCustomer": "Connexion client",
            "invalidate": "Invalider",
            "haveToPay": "Doit payer",
            "isFree": "Offert",
            "fiveMinutes": "5min",
            "tenMinutes": "10min",
            "validate": "Valider",
            "processTask": "Traiter la tâche",
            "closeTask": "Fermer la tâche",
            "clear": "Effacer",
            "close": "Fermer",
            "open": "Ouvrir",
            "saveInProgress": "Enregistrement en cours...",
            "fifteenMinutes": "15min",
            "thirtyMinutes": "30min",
            "fortyFiveMinutes": "45min",
            "oneHour": "1h",
            "oneHourAndFifteenMinutes": "1h15",
            "oneHourAndThirtyMinutes": "1h30",
            "oneHourAndFortyFiveMinutes": "1h45",
            "twoHours": "2h",
            "addTime": "Ajouter du temps",
            "reset": "Réinitialiser",
            "apply": "Appliquer",
            "filters": "Filtres",
            "add": "Ajouter",
            "edit": "Modifier",
            "compareTo": "Comparer à {to}",
            "update": "Mettre à jour",
            "cancel": "Annuler",
            "delete": "Supprimer",
            "register": "S'inscrire",
            "login": "Se connecter",
            "back": "Retour",
            "save": "Enregistrer",
            "expand": "Développer",
            "collapse": "Réduire",
            "addSubTask": "Ajouter une sous-tâche",
            "editSubTask": "Modifier la sous-tâche",
            "applyDefaults": "Appliquer les valeurs par défaut",
            "updateDefaults": "Mettre à jour les valeurs par défaut",
        },
        "error": {
            "formHasErrors": "Le formulaire contient des erreurs",
            "number": "Ce champ doit être un nombre",
            "url": "L'url est invalide",
            "hh": "hh : {message}",
            "mm": "mm : {message}",
            "passwordConfirmation": "La confirmation du mot de passe ne correspond pas",
            "email": "L'email est invalide",
            "required": "Ce champ est requis",
            "firstnameIsRequired": "Le prénom est requis",
            "lastnameIsRequired": "Le nom est requis",
            "companyIsRequired": "La société est requis",
            "emailIsRequired": "L'email est requis",
            "passwordIsRequired": "Le mot de passe est requis",
            "confirmPasswordIsRequired": "La confirmation du mot de passe est requis",
            "passwordsDontMatch": "Les mots de passe ne correspondent pas",
            "passwordMustBe8CharactersLong": "Le mot de passe doit comporter 8 caractères",
            "emailIsInvalid": "L'adresse email n'est pas valide"
        },
        "label": {
            "attachedTenants": "Sous-comptes associés",
            "Customer comment": "Commentaire client",
            "conversionTracking": "Suivi des conversions",
            "yes": "Oui",
            "no": "Non",
            "withShortDescription": "Avec description courte",
            "withoutShortDescription": "Sans description courte",
            "withDescription": "Avec description",
            "withoutDescription": "Sans description",
            "withMetaTitle": "Avec titre meta",
            "withoutMetaTitle": "Sans titre meta",
            "withMetaDescription": "Avec description meta",
            "withoutMetaDescription": "Sans description meta",
            "visible": "Visible",
            "categories": "Catégories",
            "products": "Produits",
            "title": "Titre",
            "Details": "Détails",
            "shortDescription": "Description courte",
            "metaTitle": "Titre meta",
            "metaDescription": "Description meta",
            "Import": "Importer",
            "cmsId": "ID CMS",
            "sku": "SKU",
            "enabled": "Activé",
            "content": "contenu",
            "priceWithTax": "Prix TTC",
            "quantity": "Quantité",
            "Categories": "Catégories",
            "Products": "Produits",
            "Content": "Contenu",
            "Netlinking": "Netlinking",
            "Others": "Autres",
            "History": "Historique",
            "Global": "Global",
            "Report": "Rapport",
            "Results": "Résultats",
            "Datas": "Données",
            "eCommerceProductVariationData": "Variations produit (E-commerce)",
            "eCommerceProductFeatureData": "Caractéristiques produit (E-commerce)",
            "Value": "Valeur",
            "Type": "Type",
            "day": "Jour",
            "week": "Semaine",
            "month": "Mois",
            "year": "Année",
            "Recurrence": "Récurrence",
            "Showcase": "Vitrine",
            "E-commerce": "E-commerce",
            "taskName": "Nom de la tâche",
            "realTime": "Temps",
            "invoicedTime": "Temps facturé",
            "Add": "Ajouter",
            "Customer(s)": "Client(s)",
            "Customers": "Clients",
            "Cancel": "Annuler",
            "Delete": "Supprimer",
            "Deletion": "Suppression",
            "Updated": "Mis à jour",
            "Customer": "Client",
            "Name": "Nom",
            "Description": "Description",
            "Events": "Événements",
            "update": "Mettre à jour",
            "eCommerceCustomerData": "Clients (E-commerce)",
            "Update": "Mettre à jour",
            "Position": "Position",
            "Search volume": "Volume de recherche",
            "Url": "Url",
            "Updated at": "Mis à jour le",
            "Keywords": "Mots-clés",
            "Keyword": "Mot-clé",
            "Track positions": "Suivre les positions",
            "Editing": "Édition",
            "Save": "Enregistrer",
            "displayApikomTime": "Afficher onglet “Temps Apikom”",
            "displayMonthlyTime": "Afficher le temps mensuel dans l’onglet “Temps Apikom”",
            "displayTimeEveryMondayOfTheCurrentMonth": "Afficher le temps chaque lundi du mois en cours dans l’onglet “Temps Apikom”",
            "requirements": "Besoins",
            "devPackage": "Forfait DEV",
            "yearly": "Annuel",
            "toProcess": "À traiter",
            "processed": "Traité",
            "recurrent": "Récurrent",
            "weekly": "Hebdomadaire",
            "monthly": "Mensuel",
            "serviceEndDate": "Fin prestation",
            "keywordsIdeasToFollow": "Idées de mots-clés à suivre",
            "month0": "janvier",
            "month1": "février",
            "month2": "mars",
            "month3": "avril",
            "month4": "mai",
            "month5": "juin",
            "month6": "juillet",
            "month7": "août",
            "month8": "septembre",
            "month9": "octobre",
            "month10": "novembre",
            "month11": "décembre",
            "doneAt": "Terminé le",
            "wordpress": "Wordpress",
            "shopify": "Shopify",
            "tailorMade": "Sur-mesure",
            "keywordsToFollow": "Mots-clés à suivre",
            "pagesToFollow": "Pages à suivre",
            "competitorsToFollow": "Concurrents à suivre",
            "internalNotes": "Notes internes",
            "archived": "Archivé",
            "displayOnDashboard": "Afficher sur le tableau de bord",
            "cloudflarePackage": "Forfait Cloudflare",
            "semPackage": "Forfait SEM",
            "sem": "SEM",
            "cloudflare": "Cloudflare",
            "dashboardViewer": "Visionneur du tableau de bord",
            "cmsVersion": "Version CMS",
            "phpVersion": "Version PHP",
            "magento1": "Magento 1",
            "magento2": "Magento 2",
            "prestashop": "Prestashop",
            "emailingPackage": "Forfait emailing",
            "hostingPackage": "Forfait hébergement",
            "outsourcingPackage": "Forfait infogérance",
            "shoppingfeedPackage": "Forfait shoppingfeed",
            "performanceStagePackage": "Forfait palier/perf",
            "performancePercentagePackage": "Forfait %/perf",
            "specialPackage": "Forfait spécial",
            "hosting": "Hébergement",
            "outsourcing": "Infogérance",
            "shoppingfeed": "Shoppingfeed",
            "shoppingfeed2": "SF",
            "performanceStage": "Palier/Perf",
            "performancePercentage": "%/Perf",
            "special": "Spécial",
            "other": "Autre",
            "hoursPerMonth": "Heures/mois",
            "serviceStartDate": "Début prestation",
            "severity": "Gravité",
            "seoBudgetPerMonth": "Budget SEO/mois",
            "seoPackage": "Forfait SEO",
            "seaPackage": "Forfait SEA",
            "smoPackage": "Forfait SMO",
            "smaPackage": "Forfait SMA",
            "contactPhone": "Téléphone {index}",
            "contactEmail": "Email {index}",
            "contactName": "Nom {index}",
            "seaBudgetPerMonth": "Budget SEA/mois",
            "smaBudgetPerMonth": "Budget SMA/mois",
            "roasTargetPercentage": "Pub / CA %",
            "grossMarginPercentage": "Marge brute %",
            "roas": "ROAS",
            "grossMargin": "Marge brute",
            "seoHoursPerMonth": "Heures SEO/mois",
            "seaHoursPerMonth": "Heures SEA/mois",
            "smaHoursPerMonth": "Heures SMA/mois",
            "smoHoursPerMonth": "Heures SMO/mois",
            "marketplacesHoursPerMonth": "Heures Marketplaces/mois",
            "netlinkingBudgetPerMonth": "Budget Netlinking/mois",
            "emailing": "Emailing",
            "marketplaces": "Marketplaces",
            "netlinking": "Netlinking",
            "showcase": "Vitrine",
            "eCommerce": "E-commerce",
            "contact1": "Contact 1",
            "email1": "Email 1",
            "telephone1": "Téléphone 1",
            "contact2": "Contact 2",
            "email2": "Email 2",
            "telephone2": "Téléphone 2",
            "url": "URL",
            "strategyAndObjectives": "Stratégie et objectifs",
            "startDate": "Date de début",
            "endDate": "Date de fin",
            "previousYearWithSameDate": "Année précédente (même date)",
            "eCommerceStoreData": "Sites (E-commerce)",
            "eCommerceLangData": "Langues (E-commerce)",
            "eCommerceCategoryData": "Catégories (E-commerce)",
            "eCommerceProductData": "Produits (E-commerce)",
            "eCommerceProductAttributeData": "Attributs produit (E-commerce)",
            "eCommerceCartData": "Paniers (E-commerce)",
            "eCommerceOrderData": "Commandes (E-commerce)",
            "eCommerceOrderItemData": "Lignes de commande (E-commerce)",
            "eCommerceInvoiceData": "Factures (E-commerce)",
            "eCommerceShipmentData": "Expéditions (E-commerce)",
            "eCommerceCreditMemoData": "Remboursements (E-commerce)",
            "googleAdsDailyData": "Journalier (Google Ads)",
            "facebookAdsDailyData": "Journalier (Facebook Ads)",
            "devCoefficient": "Coef DEV",
            "service": "Prestation",
            "deadlineStartDate": "Date limite de début",
            "deadlineEndDate": "Date limite de fin",
            "coefficient": "Coefficient",
            "min": "min",
            "h": "h",
            "date": "Date",
            "time": "Temps",
            "customers": "Clients",
            "taskManagers": "Responsables tâche",
            "type": "Type",
            "hourly": "Horaire",
            "package": "Forfait",
            "project": "Projet",
            "theme": "Thème",
            "seo": "SEO",
            "sea": "SEA",
            "smo": "SMO",
            "sma": "SMA",
            "dev": "DEV",
            "devSeo": "DEV SEO",
            "cs": "CS",
            "deadline": "Date limite",
            "priority": "Priorité",
            "low": "Basse",
            "medium": "Moyenne",
            "high": "Haute",
            "open": "Ouvert",
            "closed": "Fermé",
            "pageInfo": "Affichage de {firstEntry} à {lastEntry} sur {totalEntries} entrées",
            "createdAt": "Créé le",
            "customer": "Client",
            "passwordConfirmation": "Confirmation du mot de passe",
            "roles": "Rôles",
            "superAdmin": "Super administateur",
            "taskManager": "Responsable tâche",
            "fullName": "Nom complet",
            "status": "Statut",
            "price": "Prix",
            "position": "Position",
            "saleable": "Vendable",
            "preview": "Avant-première",
            "displaySuperAdminDatakepler": "Afficher le module en tant que super-admin",
            "needStoreConnector": "Requiert un connecteur site",
            "needGoogleAdsConnector": "Requiert un connecteur Google Ads",
            "needFacebookAdsConnector": "Requiert un connecteur Facebook Ads",
            "description": "Description",
            "image": "Image",
            "period": "Période",
            "custom": "Personnalisé",
            "yesterday": "Hier",
            "beforeYesterday": "Avant-hier",
            "last7Days": "7 derniers jours",
            "last30Days": "30 derniers jours",
            "last90Days": "90 derniers jours",
            "thisWeek": "Cette semaine",
            "lastWeek": "La semaine dernière",
            "thisMonth": "Ce mois-ci",
            "lastMonth": "Le mois dernier",
            "thisYear": "Cette année",
            "lastYear": "L'année dernière",
            "previousYear": "L'année précédente",
            "previousPeriod": "Période précédente",
            "compareTo": "Comparer à",
            "name": "Nom",
            "cms": "CMS",
            "turnoverOfToday": "CA du jour (vs hier)",
            "turnover": "CA",
            "seaCost": "SEA Coût",
            "turnoverPercentBySeaCost": "SEA % CA",
            "seaReturnOnAdSpend": "SEA ROAS",
            "smaCost": "SMA Coût",
            "turnoverPercentBySmaCost": "SMA % CA",
            "smaReturnOnAdSpend": "SMA ROAS",
            "turnoverPercentBySeaAndSmaCosts": "Pub / CA %",
            "actions": "Actions",
            "firstname": "Prénom",
            "lastname": "Nom",
            "company": "Société",
            "email": "Email",
            "password": "Mot de passe",
            "confirmPassword": "Confirmer le mot de passe",
            "total": "Total",
            "changePassword": "Changer le mot de passe",
            "show": "Afficher",
            "entries": "entrées",
            "id": "ID",
            "Users connections": "Connexions utilisateurs",
            "Logs types": "Types de logs",
            "User": "Utilisateur",
            "Yes": "Oui",
            "No": "Non",
            "activeTracking": "Suivi actif ?",
            "trackPositions": "Suivre les positions",
            "lastUpdate": "Dernière mise à jour",
            "appointmentFrequency": "Fréquence de rendez-vous",
            "googleWebsite": "Site Google",
            "websiteVariant": "Site",
            "targets": "Cibles",
            "nTargets": "0 cible | 1 cible | {count} cibles",
            "on": "sur",
            "language": "Langue",
            "websiteVariantTargets": "Site \"{variant}\" - Cibles",
            "defaultTargets": "Cibles par défaut",
            "shortName": "Nom court",
        },
        "link": {
            "legalNotice": "Mentions légales",
            "privacyPolicy": "Politique de confidentialité",
            "contact": "Formulaire de contact",
            "forgotPassword": "Mot de passe oublié ?",
            "logout": "Déconnexion"
        },
        "placeholder": {
            "hh": "hh",
            "mm": "mm",
            "firstname": "Votre prénom",
            "lastname": "Votre nom",
            "company": "Votre société",
            "email": "Votre adresse email",
            "password": "Votre mot de passe",
            "passwordConfirmation": "Confirmez votre mot de passe",
            "search": "Chercher..."
        },
        "suffix": {
            "perMonth": "/mois",
            "hoursPerMonth": "h/mois",
            "percentage": "%",
            "hours": "h"
        },
        "text": {
            "Maximum date completed": "Date max terminée",
            "Current maximum date": "Date max en cours",
            "Last update": "Dernière mise à jour",
            "Successfully updated": "Modifié avec succès",
            "Categories update": "Mise à jour des catégories",
            "Products update": "Mise à jour des produits",
            "Update in progress": "Mise à jour en cours",
            "Without short description": "Sans description courte",
            "Without description": "Sans description",
            "Without meta title": "Sans titre meta",
            "Without meta description": "Sans description meta",
            "Internal networking": "Maillage interne",
            "Netlinking to do": "Netlinking à faire",
            "Internal networking to do": "Maillage interne à faire",
            "Content optimisation": "Optimisation de contenu",
            "Technical optimisation": "Optimisation technique",
            "Strategy and objectives": "Stratégie et objectifs",
            "Shared notes": "Notes partagées",
            "Show details": "Afficher les détails",
            "Positions won": "Positions gagnées",
            "Positions lost": "Positions perdues",
            "Positioned URLs": "URLs positionnées",
            "Positioned keywords": "Mots clés positionnés",
            "Tracked keywords": "Mots clés suivis",
            "Tracking position": "Suivi de position",
            "Scores deleted": "Scores supprimés",
            "This deletion is permanent": "Cette suppression est définitive",
            "Deleting all scores from": "Suppression de tous les scores de",
            "Urls configured": "Urls configurées",
            "Event deleted": "Événement supprimé",
            "Task added": "Tâche ajoutée",
            "Add an event": "Ajouter un événement",
            "The deletion of this task will be permanent": "La suppression de cette tâche sera définitive",
            "unavailable": "Indisponible",
            "An error has occurred": "Une erreur est survenue",
            "Launch of update": "Lancement de la mise à jour",
            "countPositionTracked": "Nombre de positions suivies : {count}",
            "noData": "Aucune donnée disponible",
            "confirmLeaveWithoutSaving": "Voulez-vous vraiment quitter sans sauvegarder les modifications ?",
            "areYouSureToDeletePackage": "Êtes-vous sûr de vouloir supprimer le forfait #{id} ?",
            "areYouSureToDeleteCustomer": "Êtes-vous sûr de vouloir supprimer le client #{id} ?",
            "areYouSureToDeleteTaskTime": "Êtes-vous sûr de vouloir supprimer le temps de la tâche #{taskId}-{taskTimeId} ?",
            "areYouSureToDeleteTask": "Êtes-vous sûr de vouloir supprimer la tâche #{id} ?",
            "areYouSureToDeleteUser": "Êtes-vous sûr de vouloir supprimer l'utilisateur #{id} ?",
            "areYouSureToDeleteItem": "Êtes-vous sûr de vouloir supprimer cet élément ?",
            "total": "Total : {total}",
            "areYouSureToDeleteThisCustomer": "Êtes-vous sûr de vouloir supprimer ce client ? (Toutes les données seront effacées)",
            "requireFields": "Champs obligatoires",
            "successfulRegistration": "Inscription réussie. Vous recevrez un email lorsque votre compte sera prêt.",
            "loading": "Chargement en cours...",
            "areYouSureToDeleteThisUser": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
            "Client deleted successfully": "Client supprimé avec succès",
            "defaultsUpdated": "Les valeurs par défaut ont été mises à jour",
            "Entries": "Entrées",
            "Exits": "Sorties",
            "areYouSureToDeleteThisFaq": "Êtes-vous sûr de vouloir supprimer cette FAQ ?",
        },
        "item": {
            "csv": "CSV",
            "selectAllVisible": "Sélectionner tous les élements visibles",
            "selectAll": "Sélectionner tout"
        },
        "title": {
            "alerts": "Alertes",
            "deleteFaq": "Supprimer la FAQ #{id}",
            "To validate": "À valider",
            "edit": "Modifier",
            "products": "Produits",
            "categories": "Catégories",
            "Modification history": "Historique des modifications",
            "withoutShortDescription": "Sans description courte",
            "withoutDescription": "Sans description",
            "withoutMetaTitle": "Sans titre meta",
            "withoutMetaDescription": "Sans description meta",
            "Dev": "DEV",
            "realTodayTime": "Temps du jour réel",
            "realTotalTime": "Temps total réel",
            "invoicedTotalTime": "Temps total facturé",
            "Passed": "Passé",
            "Forthcoming": "À venir",
            "validated": "Validé",
            "openAndToProcess": "Ouvert/À traiter",
            "toValidate": "À valider",
            "positionMonitoringData": "Données suivi des positions",
            "positionTrackingKeywords": "Mots-clés suivi des positions",
            "Import keywords": "Importer des mots-clés",
            "contacts": "Contacts",
            "toProcess": "À traiter",
            "processed": "Traité",
            "subTasks": "Sous-tâches",
            "addSubTask": "Ajouter une sous-tâche à la tâche #{taskId}",
            "updateSubTask": "Mettre à jour la sous-tâche #{subTaskId} de la tâche #{taskId}",
            "ongoing": "En cours",
            "done": "Terminé",
            "open": "Ouvert",
            "closed": "Fermé",
            "apikomTasks": "Tâches Apikom",
            "apikomTime": "Temps Apikom",
            "updateCustomerTask": "Mettre à jour la tâche du client #{id}",
            "createCustomerTask": "Créer une tâche pour le client",
            "customerTasks": "Tâches client",
            "myTasks": "Mes tâches ({count})",
            "archived": "Archivé",
            "strategy": "Stratégie",
            "internal": "Notes internes",
            "cloudflare": "Cloudflare",
            "sem": "SEM",
            "hosting": "Hébergement",
            "performance": "Performance",
            "latestVersion": "Dernière version",
            "dev": "DEV",
            "magento1": "Magento 1",
            "magento2": "Magento 2",
            "prestashop": "Prestashop",
            "outsourcing": "Infogérance",
            "shoppingfeed": "Shoppingfeed",
            "performanceStage": "Palier/Perf",
            "performancePercentage": "%/Perf",
            "special": "Spécial",
            "emailing": "Emailing",
            "other": "Autre",
            "seo": "SEO",
            "sea": "SEA",
            "smo": "SMO",
            "sma": "SMA",
            "deletePackage": "Supprimer le forfait #{id}",
            "updatePackage": "Mettre à jour le forfait #{id}",
            "createPackage": "Créer un forfait",
            "packages": "Forfaits",
            "budgets": "Budgets",
            "services": "Prestations",
            "all": "Tous",
            "eCommerce": "E-commerce",
            "showcase": "Vitrine",
            "dashboard": "Tableau de bord",
            "projectManagement": "Gestion de projet",
            "totalTime": "Temps total",
            "times": "Temps",
            "datakepler": "Datakepler",
            "refreshData": "Rafraîchissement des données",
            "deleteCustomer": "Supprimer le client #{id}",
            "apikom": "Apikom",
            "createCustomer": "Créer un client",
            "updateCustomer": "Mettre à jour le client #{id}",
            "deleteTaskTime": "Supprimer le temps de la tâche #{taskId}-{taskTimeId}",
            "addTaskTime": "Ajouter du temps à la tâche #{taskId}",
            "updateTaskTime": "Mettre à jour le temps #{taskTimeId} de la tâche #{taskId}",
            "time": "Temps",
            "groups": "Groupes",
            "filters": "Filtres",
            "deleteTask": "Supprimer la tâche #{id}",
            "tasks": "Tâches",
            "createTask": "Créer une tâche",
            "updateTask": "Mettre à jour la tâche #{id}",
            "logs": "Logs",
            "createUser": "Créer un utilisateur",
            "updateUser": "Mettre à jour l'utilisateur #{id}",
            "users": "Utilisateurs",
            "updateModule": "Mettre à jour le module #{key}",
            "frenchContent": "Contenu français",
            "englishContent": "Contenu anglais",
            "content": "Contenu",
            "modules": "Modules",
            "customerList": "Liste des clients",
            "register": "Inscription",
            "login": "Connexion",
            "updateCustomerModules": "Mettre à jour les modules du client : {name}",
            "refreshCustomerData": "Rafraîchir les données du client : {name}",
            "loginToCustomer": "Se connecter au compte client : {name}",
            "delete": "Supprimer",
            "cancel": "Annuler",
            "information": "Informations",
            "roles": "Rôles",
            "customers": "Clients",
            "deleteUser": "Supprimer l'utilisateur #{id}"
        },
        "toast": {
            "successfullyValidated": "Validé avec succès",
            "successfullySaved": "Enregistré avec succès",
            "successfullyUpdated": "Mise à jour effectuée avec succès",
            "successfullyAdded": "Ajouté avec succès",
            "successfullyDeleted": "Supprimé avec succès",
            "loading": "Chargement en cours...",
            "successfullyUpdatedData": "Données mises à jour avec succès",
            "anErrorHasOccurred": "Une erreur est survenue"
        }
    }
};
